import React from 'react';

const LatestInsertKeyReport = () => {
  return (
    <div style={{ padding: 16 }}>
      <h2 style={{ marginBottom: 8 }}>Latest Insert Key Report</h2>
      <div style={{ color: '#64748b' }}>Coming soon</div>
    </div>
  );
};

export default LatestInsertKeyReport;
